import { FOOTER } from '@/constants/footer';
import BrandDefinition from '@/types/BrandDefinition';
import FooterDictionary from '@/types/dictionaries/Footer';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { SxProps } from '@mui/material/styles';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import FeedOutlinedIcon from '@mui/icons-material/FeedOutlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';

const styles = {
	box: {
		display: 'flex',
		alignItems: 'center',
		flex: '1 0 0',
		gap: '4px',
	},
	typography: {
		color: 'white.main',
	},
	icon: {
		height: '18px',
		width: '18px',
		color: 'grey.light',
	},
	link: {
		fontWeight: 400,
		color: 'white.main',
		':hover': {
			fontWeight: 400,
			color: 'grey.light',
		},
	},
} as const satisfies Record<string, SxProps>;

interface ServiceHotlineSectionProps {
	dict: FooterDictionary;
	brand: BrandDefinition;
	showHeading: boolean;
}

export default function ServiceHotlineSection({ dict, brand, showHeading }: Readonly<ServiceHotlineSectionProps>) {
	const footerConstants = FOOTER[brand.brandCode];

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', rowGap: '8px' }} data-testid="footer-service-hotline">
			{showHeading && (
				<Typography variant="paragraphExtraBold" data-testid="footer-service-hotline-title">
					{dict.serviceHotlineSection.title}
				</Typography>
			)}
			<Typography variant="legal" sx={{ ...styles.typography }} data-testid="footer-schedule">
				{dict.serviceHotlineSection.workHours[brand.brandCode]}
			</Typography>

			<Box sx={{ ...styles.box }} data-testid="footer-phone">
				<PhoneOutlinedIcon sx={{ ...styles.icon }} />
				<Typography sx={{ ...styles.typography }}>{footerConstants.telephone}</Typography>
			</Box>
			<Box sx={{ ...styles.box }} data-testid="footer-email">
				<EmailOutlinedIcon sx={{ ...styles.icon }} />
				<Link href={`mailto:${footerConstants.email}`} sx={{ ...styles.link }}>
					{footerConstants.email}
				</Link>
			</Box>
			<Box sx={{ ...styles.box }} data-testid="footer-contact-form-link">
				<FeedOutlinedIcon sx={{ ...styles.icon }} />
				<Link target="_blank" href={footerConstants.contactFormLink} sx={{ ...styles.link }}>
					{dict.serviceHotlineSection.contactForm}
				</Link>
				<OpenInNewOutlinedIcon sx={{ ...styles.icon }} />
			</Box>
		</Box>
	);
}
